/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentDtoApiResponse } from '../../models/amoxcalli-student-dto-api-response';
import { AmoxcalliUpdateStudentDto } from '../../models/amoxcalli-update-student-dto';

export interface ApiStudentsIdPut$Json$Params {
  id: string;
      body?: AmoxcalliUpdateStudentDto
}

export function apiStudentsIdPut$Json(http: HttpClient, rootUrl: string, params: ApiStudentsIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliStudentDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliStudentDtoApiResponse>;
    })
  );
}

apiStudentsIdPut$Json.PATH = '/api/students/{id}';
